<template>
  <!-- 内容组件外框 -->
  <div class="tag-wrap">
    <div class="tag-title">
      文章发布公众号筛选
      <el-tooltip
        popper-class="my-tooltip"
        class="item"
        effect="dark"
        content="如果选择了多个公众号，系统会列出适用于已选择的所有公众号的素材"
        placement="top-start"
      >
        <div class="el-icon-warning-outline" />
      </el-tooltip>
    </div>
    <div class="tag-list">
      <!-- <div class="tag-item" v-if="value1">
        <span>{{ value1.label }}</span>
        <i @click="del(value1.id)" />
      </div> -->
      <div class="tag-item" v-for="item in value1" :key="item.id">
        <span>{{ item.label }}</span>
        <i @click="del(item.id)"></i>
      </div>
      <el-popover
        v-model="visible"
        placement="right-start"
        width="440"
        trigger="click"
        popper-class="my-popover"
        @hide="popoverHide"
      >
        <div class="tag-popover">
          <div class="title">公众号</div>
          <el-select v-model="value" multiple placeholder="请选择" class="el-tag-select">
            <el-option
              v-for="item in publicList"
              :key="item.app_id"
              :label="item.app_name"
              :value="{ value: item.app_id, label: item.app_name }"
            />
          </el-select>
          <el-button type="primary" @click="handleBtn">确认</el-button>
          <el-button @click="visible = false">取消</el-button>
        </div>
        <div slot="reference" class="tag-plus">+</div>
      </el-popover>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagSelect',
  props: {},
  data() {
    return {
      value1: [],
      value: [],
      publicList: [],
      visible: false,
    };
  },
  mounted() {
    this.publicList = this.$store.state.user.managerLogin.app_list;
  },
  methods: {
    del(id) {
      this.value1.splice(
        this.value1.findIndex((item) => item.id === id),
        1,
      );
      //   this.value1 = '';
      this.$emit('emitAddPublic', this.value);
    },
    popoverHide() {
      this.value = this.value1;
    },
    // 确认选择
    handleBtn() {
      this.value1 = this.value;
      // if (thisvalue.length === 0) {
      //   this.$message("请选择公众号");
      //   return;
      // }
      this.$emit('emitAddPublic', this.value);
      this.visible = false;
    },
  },
};
</script>
<style lang="scss">
.my-tooltip.el-tooltip__popper.is-dark {
  background: #303133;
  color: #fff;
  height: auto;
  width: auto;
}

.my-popover {
  .popper__arrow::after {
    border-top-color: rgba(0, 0, 0, 0) !important;
  }
}
</style>
<style lang="scss" scoped>
.tag-wrap {
  .tag-title {
    margin-bottom: 12px;
  }
  .tag-list {
    display: flex;
    .tag-plus {
      background: #f5f7fa;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      font-size: 18px;
      padding: 4px 19px;
    }
    .tag-item {
      background: #f0f2f5;
      border-radius: 3px;
      box-sizing: border-box;
      padding: 6px 28px 6px 10px;
      margin-right: 10px;
      font-size: 12px;
      color: #606266;
      position: relative;
      i {
        position: absolute;
        background: #c0c4cc;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        right: 6px;
        line-height: 12px;
        font-size: 10px;
        text-align: center;
        color: #909399;
        cursor: pointer;
        &::before {
          content: '×';
        }
        &:hover {
          color: #fff;
          background-color: #909399;
        }
      }
    }
  }
}
.tag-popover {
  padding: 12px 48px;
  text-align: center;
  .title {
    font-size: 16px;
    color: #303133;
    letter-spacing: 0;
    line-height: 28px;
    text-align: left;
    margin-bottom: 10px;
  }
  .el-tag-select {
    width: 100%;
    margin-bottom: 20px;
    ::v-deep .el-input__inner {
      width: 100%;
    }
  }
}
::v-deep .el-icon-close:before {
  content: '\e6db';
}
</style>
